import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {InvitationService} from '../../service/invitation.service';

export interface PanVerificationResult {
    error?: Error;
    token?: string;
    user?: any;
}

@Injectable()
export class PanVerificationStatusResolver implements Resolve<PanVerificationResult> {
  constructor(private invitationService: InvitationService) {
  }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PanVerificationResult> {
    const inviteId = route.params.id;

    try {
        const user = await this.invitationService.getUserByInviteId(inviteId);
        if (!user) {
            const token = await this.invitationService.verifyPan(inviteId);
            return {token};
        }
        return {user};
    } catch (error) {
      return {error};
    }
  }
}
